export default __webpack_public_path__ + "static/media/WeeklyChallenge.bb2fbc63.svg";